<div class="flex flex-wrap items-center gap-2 mt-3 mb-3">
  <span
    class="inline-flex items-center gap-1.5 rounded-md border border-slate-200
           bg-slate-50 px-2.5 py-1 text-[10px] font-semibold uppercase
           tracking-wider text-slate-600"
  >
    <svg viewBox="0 0 16 16" class="size-3" fill="none" aria-hidden="true">
      <ellipse cx="8" cy="4" rx="5" ry="2" stroke="currentColor" stroke-width="1.3" />
      <path d="M3 4v8c0 1.1 2.24 2 5 2s5-.9 5-2V4M3 8c0 1.1 2.24 2 5 2s5-.9 5-2"
            stroke="currentColor" stroke-width="1.3" />
    </svg>
    Inventory Data
  </span>

  @if (ciLevel()) {
    <span
      class="rounded-md border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs
             text-slate-600"
    >
      CI Level: {{ ciLevel() }}
    </span>
  }

  <span
    class="rounded-md border border-indigo-100 bg-indigo-50 px-2.5 py-1 text-xs
           font-medium text-indigo-700"
  >
    CI Reference: {{ ciReference() }}
  </span>
</div>
